import { TimkenUnit } from '../../components/bearing-search/types/types';
import { handleActionError } from '../utils/engineering-tools';

export type PeriodicFrequenciesState = {
	units: TimkenUnit;
	operatingSpeed?: number;
	rotationSpeed: string[];
};

export const initialFrequenciesState: PeriodicFrequenciesState = {
	units: 'M',
	operatingSpeed: 60,
	rotationSpeed: [ '60' ],
};

export type PeriodicFrequenciesAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'change_operating_speed'; payload: unknown }
	| { type: 'reset'; payload?: PeriodicFrequenciesState };

const periodicFrequenciesReducer: React.Reducer<
	PeriodicFrequenciesState,
	PeriodicFrequenciesAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				units: action.payload,
			};
		}
		case 'change_operating_speed': {
			const speed = action.payload === '' ? undefined : action.payload as number;

			const newState: Partial<PeriodicFrequenciesState> = {
				operatingSpeed: speed,
			};

			if ( speed !== undefined ) {
				newState.rotationSpeed = [ `${ speed }` ];
			}

			return {
				...state,
				...newState,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialFrequenciesState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default periodicFrequenciesReducer;
